import { InPlaceEdit, Modal } from "@instructure/ui";
import { t } from "i18next";
import { useState } from "react";
import Body from "./Body";
import Footer from "./Footer";
import Header from "./Header";

const QualitySettingsModal = ({
  openModal,
  handleClose,
  qcConfig,
  setQcConfig,
  handleSave,
  loadingSaveSettings,
  selectHandler,
  id,
  error,
  interaction,
}) => {
  const [variantDescription, setVariantDescription] = useState({
    description: t("analyze.variantDescription"),
    mode: "view",
  });

  const handleChangeMode = (mode) => {
    setVariantDescription((prev) => ({ ...prev, mode: mode }));
  };

  const renderEditIcon = (props, message) => {
    props.label = message;
    return InPlaceEdit.renderDefaultEditButton(props);
  };

  return (
    <Modal
      open={openModal}
      onDismiss={handleClose}
      size="large"
      label="Edit Quality Settings"
    >
      <Modal.Header>
        <Header handleClose={handleClose} />
      </Modal.Header>

      <Modal.Body>
        <Body
          qcConfig={qcConfig}
          setQcConfig={setQcConfig}
          selectHandler={selectHandler}
          id={id}
          error={error}
          variantDescription={variantDescription}
          setVariantDescription={setVariantDescription}
          handleChangeMode={handleChangeMode}
          renderEditIcon={renderEditIcon}
          interaction={interaction}
        />
      </Modal.Body>
      <Modal.Footer>
        <Footer
          handleClose={handleClose}
          handleSave={handleSave}
          loadingSaveSettings={loadingSaveSettings}
          variantDescription={variantDescription}
          setVariantDescription={setVariantDescription}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default QualitySettingsModal;
